import { t } from 'i18next';

import { useMarketsContext } from './MarketContext';
import { useThemeContext } from '../../context/Theme';

import { MarketList } from './MarketList';
import { AssetTypesMenu } from './AssetTypesMenu';
import { Icon } from '../UI';
import { MarketsFilter } from './MarketsFilter';

export const PAGES = [
  'CRYPTO',
  'STOCK',
  'BOND',
  'FOREX',
  'ETF',
  'FUND',
  // 'OPTION',
] as const;

export const MarketDashboard = () => {
  const { toggle } = useMarketsContext();
  const { theme } = useThemeContext();

  return (
    <div>
      {/* BAR */}
      <div
        className={`
          flex
          w-full
          min-h-16
          border-grey-30
          shadow-md
          border-1
          rounded-lg
          items-center
          relative
        `}
      >
        {/* TITLE */}
        <h2 className={'pl-4 font-semibold text-xl capitalize-first'}>
          {t('common.markets')}
        </h2>

        {/* FILTER */}
        <div
          className={`
            cursor-pointer
            flex
            ml-auto
            items-center
            border-grey-30
            border-l-1
            pl-5
          `}
          onClick={() => toggle('isMarketFilterVisible')}
        >
          <span className="capitalize-first font-semibold">
            {t('common.filter.1')}
          </span>
          <Icon
            svgName="filter"
            className={`
              h-full
              w-14
              p-5
              ${theme === 'DARK' ? 'filter invert' : ''}
            `}
          />
        </div>

        <MarketsFilter />
      </div>

      {/* MENU */}
      <AssetTypesMenu />

      <MarketList />
    </div>
  );
};
